<template>
  <BreadCrumb PageTitle="Refund" />
  <RefundContent />
</template>

<script lang="ts">
import { defineComponent } from "vue";

import BreadCrumb from "../../template-components/Common/BreadCrumb.vue";
import RefundContent from "../../template-components/Ecommerce/Refund/RefundContent.vue";

export default defineComponent({
  name: "RefundPage",
  components: {
    BreadCrumb,
    RefundContent,
  },
});
</script>